// src/Views/ContactSection.js — Flasher contact list section.
import React, { useState } from 'react';
import { Eyebrow } from '../components/primitives';

const CONTACT_ROWS = [
  {
    label: 'email',
    value: 'solomon.foshko@designbydialogue.ai',
    href: 'mailto:solomon.foshko@designbydialogue.ai',
  },
  {
    label: 'call',
    value: 'calendly.com/solomon-foshko',
    href: 'https://calendly.com/solomon-foshko-designbydialogue/30min',
  },
  {
    label: 'linkedin',
    value: 'linkedin.com/in/solomonfoshko',
    href: 'https://www.linkedin.com/in/solomonfoshko/',
  },
];

function ContactRow({ label, value, href }) {
  const [hover, setHover] = useState(false);
  const isExternal = href.startsWith('http');
  return (
    <a
      href={href}
      target={isExternal ? '_blank' : undefined}
      rel={isExternal ? 'noopener noreferrer' : undefined}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        display: 'grid',
        gridTemplateColumns: 'auto minmax(0, 1fr) auto',
        gap: 14,
        alignItems: 'center',
        padding: '18px 16px',
        borderBottom: '1px solid var(--line)',
        fontFamily: 'var(--f-mono)',
        fontSize: 14,
        color: 'var(--ink-2)',
        background: hover ? 'rgba(255,177,63,0.04)' : 'transparent',
        textDecoration: 'none',
        transition: 'background 0.2s ease, color 0.2s ease',
      }}
    >
      <span
        style={{
          fontSize: 11,
          letterSpacing: '0.2em',
          textTransform: 'uppercase',
          color: 'var(--ink-3)',
          minWidth: 80,
        }}
      >
        {label}
      </span>
      <span
        style={{
          color: hover ? 'var(--magenta)' : 'var(--ink)',
          transition: 'color 0.2s ease',
          wordBreak: 'break-all',
          overflowWrap: 'anywhere',
        }}
      >
        {value}
      </span>
      <span
        aria-hidden="true"
        style={{
          color: hover ? 'var(--magenta)' : 'var(--ink-3)',
          transform: hover ? 'translateX(4px)' : 'translateX(0)',
          transition: 'color 0.2s ease, transform 0.2s ease',
        }}
      >
        ↗
      </span>
    </a>
  );
}

const ContactSection = () => {
  return (
    <section id="contact" style={{ position: 'relative', padding: '140px 28px', zIndex: 2 }}>
      <div
        className="contact-grid"
        style={{
          maxWidth: 1080,
          margin: '0 auto',
          display: 'grid',
          gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)',
          gap: 64,
          alignItems: 'start',
        }}
      >
        <div>
          <Eyebrow accent="var(--magenta)">⏵ INITIATE.DIALOGUE</Eyebrow>
          <h2
            style={{
              fontFamily: 'var(--f-display)',
              fontSize: 'clamp(40px, 5.5vw, 80px)',
              fontWeight: 600,
              lineHeight: 1.1,
              letterSpacing: '-0.03em',
              margin: 0,
              color: 'var(--ink)',
              paddingBottom: '0.1em',
            }}
          >
            Have a problem
            <br />
            <span
              style={{
                fontStyle: 'italic',
                fontWeight: 400,
                background: 'linear-gradient(120deg, var(--magenta), var(--cyan))',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                paddingRight: '0.18em',
                paddingBottom: '0.05em',
              }}
            >
              worth building for?
            </span>
          </h2>
          <p
            style={{
              fontSize: 17,
              lineHeight: 1.6,
              color: 'var(--ink-2)',
              marginTop: 28,
              maxWidth: 440,
            }}
          >
            I take on a small number of paid engagements. If you have a domain problem that
            needs systems thinking and AI execution, let's talk.
          </p>
        </div>

        <div
          style={{
            padding: 8,
            borderRadius: 20,
            background: 'rgba(15, 13, 42, 0.55)',
            border: '1px solid var(--line-strong)',
            backdropFilter: 'blur(14px)',
            WebkitBackdropFilter: 'blur(14px)',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: 3,
              background: 'linear-gradient(90deg, var(--magenta), var(--purple), var(--cyan))',
            }}
          />
          {CONTACT_ROWS.map((row, i, arr) => (
            <div
              key={row.label}
              style={{ borderBottom: i === arr.length - 1 ? 'none' : undefined }}
            >
              <ContactRow {...row} />
            </div>
          ))}
          <div
            style={{
              padding: '14px 16px',
              fontFamily: 'var(--f-mono)',
              fontSize: 11,
              letterSpacing: '0.2em',
              color: 'var(--ink-3)',
              textTransform: 'uppercase',
            }}
          >
            TYPICAL.REPLY &lt; 48H
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
